export const hitSlop = { top: 10, bottom: 10, left: 10, right: 10 };
